export const T = {
  en_GB: {
    prevMonth: "Previous month",
    nextMonth: "Next month",
    chooseMonth: "Month",
    chooseYear: "Year",
    today: "Today",
    clear: "Clear",
    invalidDate: "Enter a complete date",
    openCalendar: "Open calendar",
    weekdaysShort: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
  nb_NO: {
    prevMonth: "Forrige måned",
    nextMonth: "Neste måned",
    chooseMonth: "Måned",
    chooseYear: "År",
    today: "I dag",
    clear: "Tøm",
    invalidDate: "Angi en fullstendig dato",
    openCalendar: "Åpne kalender",
    weekdaysShort: ["Ma", "Ti", "On", "To", "Fr", "Lø", "Sø"],
    months: [
      "Januar",
      "Februar",
      "Mars",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Desember",
    ],
  },
} as const;
